module.exports = __webpack_public_path__ + "media/activity-level/cavapoo-leisurely-d21a6f36.svg";